import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONSTANSTS } from '@core/constants';
import { Observable } from 'rxjs';

@Injectable()
export class MapsService {

  constructor(private readonly http: HttpClient) { }

  /**
   * bildirimleri çekiyoruz.
   */
  getNotificationsFromMessageCenter(): Observable<any> {
    return this.http.post<any>(CONSTANSTS.api.maps.notificationsFromMessageCenter, {});
  }

}
